import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a870a598")

_pushScopeId("data-v-a870a598")
const _hoisted_1 = { class: "p-my-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-my-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("li", null, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.associatedWord')) + ":", 1),
      _createVNode("ul", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.wordsList, (column, index) => {
          return (_openBlock(), _createBlock("li", {
            key: index,
            class: ["glossary-info-word", { 'selected-word': _ctx.wordIsSelected(column) }]
          }, [
            _createVNode("span", null, _toDisplayString(column.WORD), 1)
          ], 2))
        }), 128))
      ])
    ]),
    (_ctx.columnField)
      ? (_openBlock(), _createBlock("li", _hoisted_2, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.column')) + ":", 1),
          _createVNode("ul", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (column, index) => {
              return (_openBlock(), _createBlock("li", { key: index }, [
                _createTextVNode(_toDisplayString(column[_ctx.columnField]) + " ", 1),
                _createVNode("ul", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.word, (word, index) => {
                    return (_openBlock(), _createBlock("li", {
                      key: index,
                      class: ["glossary-info-word", { 'selected-word': _ctx.wordIsSelected(word) }]
                    }, [
                      _createVNode("span", null, _toDisplayString(word.WORD), 1)
                    ], 2))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})